import './advisory.css';
import { useState } from 'react';
import blackwell from '../images/blwekk.jpeg';
import shuwanda from '../images/updated_shuwanda.jpg';
import anna from '../images/ana.JPEG';
import settings from './about.js';
import Slider from 'react-slick';
import candra from '../images/misscandra.JPG'


function Advisory() {
    const [isBioOpen, setisBioOpen] = useState(false);
    const [bio, setBio] = useState();

    const board_data = [
    {
        name: "Candra Cummings, MD",
        img: candra,
        role:"Chief Medical Advisor"
    },
    {
        name: "Anna Kelly",
        img: anna,
        role:"PreMed Student Advisor"
    },
    {
        name: "Ron Blackwell",
        img: blackwell,
        role:"Financial Advisor"
    },
    {
        name: "Shuwanda Williams",
        img: shuwanda,
        role:"Accounting Advisor"
    }
    ]

    const board_bio = 
    {
        0: `Dr. Candra Cummings is a distinguished board-certified anesthesiologist whose impressive career spans over three decades, marked by a profound commitment to patient care and medical excellence. Hailing from the culturally rich City of Brotherly Love, Philadelphia, and nurtured in the dynamic landscape of New York City, Dr. Cummings seamlessly blends compassion with unparalleled expertise. A graduate of the esteemed Albert Einstein College of Medicine in the Bronx, where she received her medical degree in 1993, Dr. Cummings distinguished herself through innovative clinical research exploring the intricate relationship between scoliosis and respiratory function in children. Dr. Candra Cummings has consistently showcased her extraordinary expertise and leadership within the medical realm, earning the esteemed accolade of "Top Doctor" from her peers and staff at Prince George’s Medical Center in both 2013 and 2014. Her remarkable contributions to the field culminated in her appointment as Vice Chairman of the Anesthesiology Department at Prince George’s Hospital in Maryland, where she has significantly elevated patient care standards and fostered departmental excellence. Her dedication to her craft has also been recognized through her inclusion in the prestigious "Who’s Who in Colleges and Universities" in both 1987 and 1988, underscoring her commitment to academic and professional distinction. Beyond her impressive medical career, Dr. Cummings is a devoted philanthropist, actively working to improve healthcare access and education for underserved communities. Her commitment to excellence and service has inspired countless individuals, making her a true leader in both medicine and community advocacy.`,

        1: `Anna is currently an M.D. Candidate at the Johns Hopkins University School of Medicine. Anna holds a Bachelor of Science in Bioengineering and a minor in Chemistry from the University of Pittsburgh where she graduated magna cum laude. Throughout her time in Pittsburgh, Anna worked at an educational nonprofit for several years where she served as a Lego Robotics and STEM Team coach for African American middle schoolers. She also led the University of Pittsburgh chapter of the National Society of Black Engineers (NSBE) all four years of college as the Pre-College Initiative Chair, where she organized outreach programs exposing local students to STEM, and subsequently as the Vice President, where she increased membership engagement and executive board accountability through creative initiatives. Anna's community service extended through various other mediums such free health clinic volunteering, math and science tutoring, and first year engineering student mentorship. Anna's commitment to science is further reflected in her several years of tissue engineering and vascular kinetics research which culminated in numerous conference presentations, a manuscript, and honors from the NIH, NSBE, and the University of Maryland. Anna is excited to share all she has learned with future pre-medical students to aid in their success.`,

        2: `Ron Blackwell is a Financial Services Specialist. Ron has more than several years of experience in the industry and take pride in providing my clients with knowledgeable advice that is consistent with their long term financial goals. His goal is to assist individuals, families and small business owners in the growth, protection, and accumulation of their assets, to help them move from financial stability, to financial security, and ultimately to financial freedom, thus creating a legacy for future generations. This is accomplished by listening to each client's needs, providing practical and considerate options that reflect their unique situation, and by helping them implement appropriate strategies to meet their financial goals at every stage of their lives.`,
        
        3:`Shuwanda serves as an accounting and financial manager and certified public accountant (CPA) for various small businesses and individuals. In this position, she provides executive officers and business mangers with information to run accounting departments, to enhance internal control and to forecast/budget for future growth. Her duties include financial statement preparation, audits, budget preparation, tax analysis, and proposal writing. As an accounting manager, she oversees general accounting functions, cash management and administers software applications for clients as requested. Shuwanda trains and develops accounting and financial management skill sets for staff on behalf of clients. As a CPA, she provides strategic guidance with the Board of Directors and Presidents or Chief Executive Officers of companies concerning financial direction/management and leadership development. Client base includes an asset management range of $200K to $15 million and revenue range of $250K to $20 million.`
    }
    const fetchBio = (bioId) => {
        try {
            setisBioOpen(true);
            setBio(bioId);

        } catch (err) {
            console.error("Failed to fetch Bio:", err.response?.data || err.message);
        }
    };
    const closeBio = () => {
        setisBioOpen(false);  
    };
    return(
        <div className="advisory-container">
            <h2>Meet Our Advisory Board</h2>
            {!isBioOpen && (
                <section className = 'section4'>
                <p>FAAMS is supported by a multidisciplinary medical advisory team that provides clinical insight and strategic guidance.
                     The team includes physicians with expertise in anesthesiology, internal medicine–pediatrics, and emergency medicine,
                      ensuring that the program is informed by diverse clinical perspectives. Certain advisors serve in a confidential
                       capacity.</p>
                <div className='board'>
                    <Slider {...settings}>
                    {board_data.map((d) => (
                        <div className='board-cards'>
                            <div className='top-board-card'>
                                <img src={d.img}/>
                            </div>
                            <div className ='bottom-board-card'>
                                <h3 onClick={() => fetchBio(board_data.indexOf(d))}>{d.name}</h3>
                                <p>{d.role}</p>
                            </div>
                        </div>
                    )
                )}
                </Slider>
                </div>
            </section>)}
            {isBioOpen && (
                <div className='bio-section'>
                    <div className='bio-header'>
                        <div className='bio-header-left'>
                            <h3>{board_data[bio].name}</h3>
                            <p>{board_data[bio].role}</p>
                        </div>
                        <div className='bio-header-right'>
                            <img src={board_data[bio].img}/>
                        </div>
                    </div>
                    <div className='bio-p'>
                        {board_bio[bio]}
                    </div>
                    <button className='bio-back' onClick={closeBio}>Back</button>
                </div>
                )}
        </div>

    )
}

export default Advisory;